import { forwardRef } from "react";

import Icon from "@/components/Icon";
import LunaConfusedSVG from "./LunaConfusedIcon.svg.jsx";
import type { IconProps } from "@/components/Icon/Icon";

const LunaConfusedIcon = forwardRef<
  SVGSVGElement,
  Omit<IconProps, "SvgComponent">
>((props, ref) => {
  return <Icon ref={ref} SvgComponent={LunaConfusedSVG} {...props} />;
});

export default LunaConfusedIcon;
